import { jsx as _jsx } from "react/jsx-runtime";
import { Breadcrumbs } from "@air/component-breadcrumbs";
import { tailwindMerge } from "@air/tailwind-variants";
import classNames from "classnames";
import { memo, useMemo } from "react";
export const BoardAncestorPath = /*#__PURE__*/ memo((param)=>{
    let { ancestors, className } = param;
    const ancestorsItems = useMemo(()=>{
        const items = [];
        const boardAncestors = ancestors !== null && ancestors !== void 0 ? ancestors : [];
        items.push(...boardAncestors.map((ancestor, index)=>({
                className: classNames("truncate font-normal text-inherit", index === 0 ? "pl-0" : ""),
                id: ancestor.id,
                label: ancestor.title,
                type: "item"
            })));
        return items;
    }, [
        ancestors
    ]);
    if (ancestors.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Breadcrumbs, {
        isCompact: true,
        className: tailwindMerge("overflow-visible text-12 text-grey-10", className),
        items: ancestorsItems
    });
});
BoardAncestorPath.displayName = "BoardAncestorPath";
